import { DocumentUploadSlot } from '@/components/molecules/checkIn/document-upload-slot'
import { DocumentSlotView } from '@/hooks/use-document-slots'
import { spacerTopStyle } from '@/styles/common'
import React from 'react'

type Props = {
  slots: DocumentSlotView[]
}

export const DocumentSlotList: React.FC<Props> = ({ slots }) => (
  <>
    {slots.map(({ slotId, ...slotProps }) => (
      <div css={spacerTopStyle} key={slotId}>
        <DocumentUploadSlot {...slotProps} />
      </div>
    ))}
  </>
)
